/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { userSchema } from './user-schema';
import { TokenPolicyAction, TokenPolicyEffect } from "../enums";

export const tokenSchema: z.AnyZodObject = z.object({
  createdAt: z.string().datetime().nullish(),
  expiresAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  policy: 
    z.object({
      statements: 
        z.array(
          z.object({
            action: z.nativeEnum(TokenPolicyAction).nullish(),
            effect: z.nativeEnum(TokenPolicyEffect).nullish(),
            resource: z.string().nullish(),
          })
        )
      .nullish(),
      version: z.string(),
    })
  .nullish(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
  userId: z.string().uuid().nullish(),
});

export type Token = z.infer<typeof tokenSchema>;
